import axios from "axios";

import { useMutation } from "@tanstack/react-query";

// `body` accepts `Blob`/`File` (for chat-attachment uploads — sent as raw
// binary), `string` (legacy callers uploading JSON or text), or `ArrayBuffer`.
// The content-type header must match what the presigned URL was issued for.
const uploadToPresignedUrl = async ({
  presignedUrl,
  body,
  contentType,
}: {
  presignedUrl: string;
  body: Blob | File | ArrayBuffer | string;
  contentType: string;
}): Promise<void> => {
  await axios.put(presignedUrl, body, {
    headers: { "Content-Type": contentType },
  });
};

export const useUploadToPresignedUrl = () => {
  return useMutation({
    mutationFn: uploadToPresignedUrl,
  });
};
